import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import {
  Container, Tabs, Tab, Row, Col,
} from 'react-bootstrap';
import axios from 'axios';
import Pengajuan from './pengajuan';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';
import config from '../../../../config';

const DaftarPartisipasi = () => {
  const [status, setStatus] = useState('menunggu persetujuan');
  const [loading, setLoading] = useState(true);
  const [datas, setDatas] = useState([]);

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/?status=${status}`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const simplifyData = data.map((
          (content) => (
            {
              nama: content.kum.nama_kegiatan,
              url: `/Mahasiswa/DetailPengajuanPartisipasi/${content.id}`,
            }
          )
        ));
        setDatas(simplifyData);
        setLoading(false);
      },
    );
  }, [status]);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <>
      <Container className="container-list">
        <Tabs
          className="w-100 nav-fill"
          id="controlled-tab"
          data-testid="date"
          activeState={status}
          onSelect={(k) => setStatus(k)}
        >
          <Tab eventKey="menunggu persetujuan" title="Menunggu Persetujuan" />
          <Tab eventKey="disetujui" title="Disetujui" />
          <Tab eventKey="ditolak" title="Ditolak" />
        </Tabs>
        <Row className="mt-3 border-dark border-bottom ml-1 mr-1">
          <Col><p>Nama Event</p></Col>
          <Col><p>Detail</p></Col>
        </Row>
        <div className="mt-3">
          {datas.map((
            (data) => <Pengajuan nama={data.nama} url={data.url} />
          ))}
        </div>
      </Container>
    </>
  );
};

export default DaftarPartisipasi;
